'use client'

import { Card } from "@/components/ui/card"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel"
import { IMAGE_TESTIMONIALS, VIDEO_TESTIMONIALS } from "@/lib/constants"
import Image from "next/image"

export function Testimonials() {
  return (
    <section 
        id="testimonials" 
        className="bg-secondary"
    >
      <div
        className="container mx-auto px-4 max-w-6xl"
      >
        <div className="text-center space-y-4 mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-headline">What Parents Say</h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            We are proud to have earned the trust of thousands of parents worldwide.
          </p>
        </div>

        <div className="space-y-16">
          <div>
            <h3 className="text-2xl md:text-3xl font-bold font-headline mb-8 text-center">Video Testimonials</h3>
            <Carousel
              opts={{
                align: "start",
                loop: true,
              }}
              className="w-full mx-auto"
            >
              <CarouselContent>
                {VIDEO_TESTIMONIALS.map((testimonial, index) => {
                  return (
                    <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                      <div className="p-1 h-full">
                        <Card className="h-full shadow-lg overflow-hidden">
                          {testimonial.videoUrl && (
                            <div className="aspect-video w-full">
                              <iframe
                                className="w-full h-full"
                                src={testimonial.videoUrl}
                                title={`Testimonial video ${index + 1}`}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                              ></iframe>
                            </div>
                          )}
                        </Card>
                      </div>
                    </CarouselItem>
                  )
                })}
              </CarouselContent>
              <CarouselPrevious />
              <CarouselNext />
            </Carousel>
          </div>

          <div>
            <h3 className="text-2xl md:text-3xl font-bold font-headline mb-8 text-center">Image Testimonials</h3>
            <Carousel
              opts={{
                align: "start",
                loop: true,
              }}
              className="w-full mx-auto"
            >
              <CarouselContent>
                {IMAGE_TESTIMONIALS.map((testimonial, index) => {
                  return (
                    <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                      <div className="p-1 h-full">
                        <Card className="h-full shadow-lg overflow-hidden">
                          {testimonial.imageUrl && (
                            <div className="relative aspect-video w-full">
                              <Image
                                src={testimonial.imageUrl}
                                alt={`Testimonial image ${index + 1}`}
                                fill
                                className="object-contain"
                                sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 33vw"
                              />
                            </div>
                          )}
                        </Card>
                      </div>
                    </CarouselItem>
                  )
                })}
              </CarouselContent>
              <CarouselPrevious />
              <CarouselNext />
            </Carousel>
          </div>
        </div>
      </div>
    </section>
  )
}
